module.exports = __webpack_public_path__ + "img/img_product_single.d479f933.png";